export const SHARE_LEVEL = {
  view: 0,
  edit: 1
};
